import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const AddBannerLayer = ({ handleClose, refreshTable }) => {
  const [formData, setFormData] = useState({
    nickname: "",
    image: "", // Base64 string for the image
    project_id: "", // Add project_id to formData
  });

  const [error, setError] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  // Handle File Input and Convert to Base64 with image validation
  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    const maxSize = 3 * 1024 * 1024; // 3MB
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!file) return;
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, JPEG, or PNG files are allowed.");
      return;
    }
    if (file.size > maxSize) {
      toast.error("File size exceeds 3MB.");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData({ ...formData, [fieldName]: reader.result }); // Save as Base64
    };
    reader.readAsDataURL(file);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(); // Clear previous errors

    setLoading(true);
    try {
      const response = await api.post("/banners", formData);
      if (response.data.status) {
        toast.success("Banner added successfully!");
        refreshTable(); // Refresh the table data
        handleClose(); // Close the modal
      }
    } catch (err) {
      const errorResponse = err.response?.data?.message;
      toast.error(errorResponse || ["An error occurred"]);
      setError(Object.values(errorResponse).flat());
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel button
  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-8 col-lg-10">
            <div className="card border">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Project ID Input */}
                  <div className="mb-20">
                    <label
                      htmlFor="project_id"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Project ID
                    </label>
                    <input
                      type="number"
                      className="form-control radius-8"
                      id="project_id"
                      placeholder="Enter Project ID (optional)"
                      value={formData.project_id}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Nickname Input */}
                  <div className="mb-20">
                    <label
                      htmlFor="nickname"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Nickname <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="nickname"
                      placeholder="Enter nickname"
                      value={formData.nickname}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Picture Upload */}
                  <div className="mb-20">
                    <label
                      htmlFor="image"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Image <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control radius-8"
                      id="image"
                      onChange={(e) => handleFileChange(e, "image")}
                      required
                    />
                  </div>

                  {/* Buttons */}
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBannerLayer;